var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.921 7.33862L16.3717 0.583328H13.9389L9.77867 5.74262L6.08792 0.583328H0.791672L6.97142 9.22041L1.16376 16.4167H3.59734L8.1138 10.8196L12.1204 16.4167H17.4167L10.921 7.33862ZM9.03688 9.67404L7.89292 8.07566L3.45167 1.87137H5.28042L8.86509 6.87233L10.0075 8.47149L14.7717 15.1286H12.943L9.03688 9.67404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f9ed4324b12df8f2bad92121b5dbf91a.svg";
export { ForwardRef as ReactComponent };